/** https://blog.pshrmn.com/a-little-bit-of-history/ */

import { createBrowserHistory } from "history";

const history = createBrowserHistory();

export { history };
